import React, { useEffect } from "react";
import "./Workflow.css";
import NavbarComp from "../../Common/Navbar/Navbar";
import FileManagerSidebar from "../JupyterNotebook/FileManagerSidebar/FileManagerSidebar";
import WorkFLowMainComp from "./Notebook";
import { useWorkflowContext } from "./WorkflowContext/WorkflowContext";
import WorkFlowInputStep from "./WorkFlowInputStep";
import { VscRunAll } from "react-icons/vsc";

const WorkflowComp = (props) => {
    const {
        state,
        RunCodeCells,
        StopCodeExecution,
    } = useWorkflowContext();
    const [workflowData, setworkflowData] = React.useState({});
    const workflowName = props.workflowName
    const [stepsData, setStepsData] = React.useState([]);
    const [stepsExecuted, setStepsExecuted] = React.useState({});
    const [selectedStep, setSelectedStep] = React.useState(0);
    const [hideCodeBlocks, setHideCodeBlocks] = React.useState(false);
    const [hideOutputBlocks, setHideOutputBlocks] = React.useState(false);
    const [DisplayCodeType, setDisplayCodeType] = React.useState("show-relevant");
    const PreProcessingStepsData = (steps) => {
        const returndata = []
        steps.map((step) => {
            const stepName = Object.keys(step)[0];
            const tempdict = step[stepName];
            tempdict["stepName"] = stepName;
            tempdict["status"] = 0;
            tempdict["output"] = {};
            tempdict["tasks"] = { "outputs": {} }
            returndata.push(tempdict);
        })
        return returndata;
    }
    const handleStepClick = (index) => {
        setDisplayCodeType("show-relevant")
        setSelectedStep(index);
    }
    useEffect(() => {
        const tempWorkflow = props.workflowData;
        if (tempWorkflow && tempWorkflow.metadata && tempWorkflow.code) {
            setworkflowData(tempWorkflow);
            if (tempWorkflow.metadata.steps) {
                setStepsData(PreProcessingStepsData(tempWorkflow.metadata.steps))
            }
        }
    }, [props])
    const selectedStepDetails = selectedStep >= 0 ? stepsData[selectedStep] : null;
    const ExecuteWorkFlowStep = (Run_cells = [0, -1]) => {
        setStepsExecuted(prevData => {
            const tempData = { ...prevData };
            tempData[selectedStep] = 1;
            return tempData;
        });
        const DisplayCellsList = state.notebook?.cells?.slice(Run_cells[0], Run_cells[1] >= 0 ? Run_cells[1] : state.notebook?.cells.length);
        let codeToRun = "";
        DisplayCellsList.map((cell, index) => {
            const cellIndex = index + Run_cells[0];
            if (cell.cell_type === "code") {
                codeToRun = codeToRun + "\n" + cell.source.join('');
                RunCodeCells(cellIndex, cell.source.join(''));
            }
        })
    }
    // const getStepOutput = (Run_cells = [0, -1]) => {
    //     const DisplayCellsList = state.notebook?.cells?.slice(Run_cells[0], Run_cells[1] >= 0 ? Run_cells[1] : state.notebook?.cells.length);
    //     let outputs = [];
    //     DisplayCellsList.map((cell) => {
    //         if (cell.cell_type === "code" && cell.outputs) {
    //             outputs = outputs.concat(cell.outputs);
    //         }
    //     })
    //     return outputs;
    // }
    // const DisplayCodeCells = DisplayCodeType === "show-relevant" ? selectedStepDetails?.display_cell :
    //     DisplayCodeType === "show-code" ? selectedStepDetails?.run_cell : [0, 0]

    const checkIfSelectedStepIsExecuting = (Run_cells = [0, -1]) => {
        let isExecuting = false;
        const endIndex = Run_cells[1] >= 0 ? Run_cells[1] : state.notebook?.cells.length;
        for (var i = Run_cells[0]; i < endIndex; i++) {
            if (state.cellExecutionDetails[i].isExecuting) {
                isExecuting = true;
                return true;
            }
        }
        return isExecuting;
    }
    const checkSelectedStepStatus = (Run_cells = [0, -1]) => {
        let ok = true;
        const RunCellsList = state.notebook?.cells?.slice(Run_cells[0], Run_cells[1] >= 0 ? Run_cells[1] : state.notebook?.cells.length);
        RunCellsList?.map((cell) => {
            if (cell.cell_type === "code" && cell.outputs) {
                if (ok) {
                    const outputs = cell.outputs;
                    outputs.map((output) => {
                        if (output['output_type'] === "error") {
                            ok = false;
                            return false;
                        }
                    })
                }
            }
        })
        return ok;
    }
    const StepCellsIsExecuting = checkIfSelectedStepIsExecuting(selectedStepDetails?.run_cell);
    if (!state.notebook || !('cells' in state.notebook)) return <div>Loading...</div>
    return (
        <>
            <div className="workflow-page">
                <NavbarComp />
                <div className="workflow-container">
                    <div className="workflow-FileManager custom-scrollbar">
                        <FileManagerSidebar />
                    </div>
                    <div className="workflow-div">
                        <div className="workflow-heading">
                            <h2>{workflowName}</h2>
                        </div>
                        <div className="workflow-steps-oval">
                            {stepsData.map((step, index) => {
                                var classnames = "";
                                if (selectedStep === index) classnames = " workflow-step workflow-step-active";
                                else if (stepsExecuted[index] === 1 && checkSelectedStepStatus(step.run_cell)) classnames = " workflow-step workflow-step-done";
                                else classnames = "workflow-step"
                                return (<>
                                    {index > 0 && <div className="progress-line"></div>}
                                    <div className={classnames}>
                                        <button onClick={() => { handleStepClick(index) }} className="step-button">{step.stepName}</button>
                                        {/* <button onClick={() => { handleStepClick(index) }} className="step-button">Step-{index + 1}</button> */}
                                    </div>
                                </>)
                            })}
                        </div>
                        {selectedStep >= 0 &&
                            <div className="workflow-run-div custom-scrollbar">
                                <div className="step-details-main custom-scrollbar">
                                    <div className="step-details-heading">
                                        <h4>{selectedStepDetails?.stepName}</h4>
                                        {/* <div><button onClick={() => { ExecuteWorkFlowStep(selectedStepDeta
                                            ils.run_cell) }}>Execute</button> </div> */}
                                        {/* <div><button onClick={() => { setHideCodeBlocks(!hideCodeBlocks) }}>{hideCodeBlocks ? "Display Code" : "Hide Code"}</button> </div> */}
                                        <div className="cwc-navbar-select-div">
                                            <select className="cwc-navbar-select-button" value={DisplayCodeType} onChange={(e) => { setDisplayCodeType(e.target.value) }}>
                                                <option value="hide-code">Hide Code</option>
                                                <option value="show-relevant">Show relevant Code</option>
                                                <option value="show-code">Show Complete Code</option>
                                                {/* <option value="option3">Option 3</option> */}
                                            </select>
                                        </div>
                                    </div>
                                    {selectedStepDetails?.stepName === "input_data" &&
                                        <><WorkFlowInputStep /></>
                                    }
                                    {DisplayCodeType === "show-relevant" && <WorkFLowMainComp
                                        initialData={workflowData}
                                        Display_code_cells={selectedStepDetails?.display_cell}
                                        Display_output_cells={[0, 0]}
                                        // hideOutputBlocks={false}
                                        hideOutputBlocks={hideOutputBlocks}
                                        hideCodeBlocks={hideCodeBlocks}
                                    />}
                                    <div className="custom-execute-button-div">
                                        {
                                            StepCellsIsExecuting ? <button className="custom-execute-button" onClick={() => { StopCodeExecution() }}>
                                                Stop Execution
                                            </button> :
                                                <>
                                                    <button className="custom-execute-button" onClick={() => { ExecuteWorkFlowStep(selectedStepDetails?.run_cell) }}>
                                                        Execute <VscRunAll />
                                                    </button>
                                                    {
                                                        (selectedStep < stepsData.length - 1 && stepsExecuted[selectedStep] === 1 && checkSelectedStepStatus(selectedStepDetails?.run_cell)) ?
                                                            <button className="custom-next-button" onClick={() => { setSelectedStep(selectedStep + 1) }}>
                                                                Next Step
                                                            </button>
                                                            : <></>
                                                    }

                                                    {/* {

                                                        (stepsExecuted[index] === 1 && checkSelectedStepStatus(step.run_cell) ? <></>:<></>
                                                    } */}
                                                </>
                                        }


                                    </div>
                                    <div style={{ marginLeft: "50px" }}>
                                        <h3>Outputs</h3>
                                    </div>
                                    <WorkFLowMainComp
                                        initialData={workflowData}
                                        Display_code_cells={DisplayCodeType === "show-code" ? selectedStepDetails?.run_cell : [0, 0]}
                                        Display_output_cells={selectedStepDetails?.run_cell
                                        }
                                        // hideOutputBlocks={false}
                                        hideOutputBlocks={hideOutputBlocks}
                                        hideCodeBlocks={hideCodeBlocks}
                                    />
                                </div>
                                <div className=""></div>
                            </div>
                        }
                        {selectedStep < 0 && <div className="workflow-doc custom-scrollbar">
                            {/* <div><RunNotebook rawIpynb1={notebookCode} /></div> */}
                            <div >{JSON.stringify(workflowData)}</div>
                        </div>}
                    </div>

                </div>
            </div>

        </>
    )
}
export default WorkflowComp;